import 'C:\\Projects\\genkei\\zumeco\\static\\shared\\components\\Icon.tsx.esbuild-plugin-linaria.css';
import 'C:\\Projects\\genkei\\zumeco\\static\\shared\\components\\Icon.tsx.esbuild-plugin-windicss.css';
import { css, cx } from '@linaria/core';
import { JSX } from 'preact';
import { memo } from 'preact/compat';
const IconSvg = ({
  className,
  color,
  size = 24,
  children
}: {
  className?: string;
  color?: string;
  size?: number;
  children: JSX.Element | readonly JSX.Element[];
}) => <svg viewBox="0 0 24 24" width={size} height={size} vertical-align="middle" className={className} style={color && {
  color
}}>
    {children}
  </svg>;
export const Icon = memo(({
  icon,
  line,
  className,
  color,
  size
}: {
  icon: string;
  line?: boolean;
  className?: string;
  color?: string;
  size?: number;
}) => <IconSvg size={size} className={className} color={color}>
      {line ? <path stroke="currentColor" stroke-width="2" d={icon} /> : <path fill="currentColor" d={icon} />}
    </IconSvg>);
export const IconAndText = memo(({
  icon,
  line,
  text,
  iconClass,
  textClass,
  children
}: {
  icon?: string;
  line?: boolean;
  text: string;
  iconClass?: string;
  textClass?: string;
  children?: JSX.Element | readonly JSX.Element[];
}) => <div class={"d17tun10"}>
      {icon && <Icon icon={icon} line={line} className={iconClass} />}
      {children && <IconSvg className={iconClass}>{children}</IconSvg>}
      <div data-text={text} class={cx(text.length === 5 && "d1wgtrud", textClass)}>
        {text}
      </div>
    </div>);

// https://iconoir.com
const IconoirIcon = ({
  d
}: {
  d: string;
}) => <svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none">
    <path d={d} />
  </svg>;
export const iconEye = <IconoirIcon d="M3 13C6.6 5 17.4 5 21 13M12 17C10.3431 17 9 15.6569 9 14C9 12.3431 10.3431 11 12 11C13.6569 11 15 12.3431 15 14C15 15.6569 13.6569 17 12 17Z" />;
export const iconEyeClosed = <IconoirIcon d="M19.5 16L17.0248 12.6038M12 17.5V14M4.5 16L6.96895 12.6124M3 8C6.6 16 17.4 16 21 8" />;